import React from 'react';

/** EstadoVazio — lista sem registros. Diz o que falta e o que fazer. */
export default function EstadoVazio({ icone = 'inbox', titulo, texto, acao }) {
  return (
    <div className="sj-vazio" role="status">
      <span className="sj-icone sj-vazio__icone" aria-hidden="true">{icone}</span>
      <p className="sj-vazio__titulo">{titulo}</p>
      {texto && <p className="sj-vazio__texto">{texto}</p>}
      {acao}
    </div>
  );
}
